import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Card, Checkbox, Button } from '@/components/UIComponents/index';
import store from "@/store";
let UserDashboardViewModel = class UserDashboardViewModel extends Vue {
    constructor() {
        super();
        this.myReservations = new Array();
        this.myEvents = new Array();
    }
    handleReservationView(index, reservation) {
        window.open(reservation.redirectUrl, "_blank");
    }
    async mounted() {
        if (process.env.VUE_APP_ENV === "DEV") {
            // @ts-ignore
            store.state.oidcStore.access_token = await Identity.getUserAccessToken('dlight20@gmail.com', 'Smokey20');
        }
        try {
            // @ts-ignore
            //this.myReservations = await Reservation.getUpcomingReservations(store.state.oidcStore.access_token);
        }
        catch (error) {
            console.log('Failed the upcoming reservations call. ' + error);
        }
    }
};
UserDashboardViewModel = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button,
        }
    })
], UserDashboardViewModel);
export default UserDashboardViewModel;
